var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 74,
    viewBox: "0 0 81 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 3.45312L3 14.7865M78 14.7865L66.75 3.45312M18 63.8976L10.5 71.4531M63 63.8976L70.5 71.4531M40.5 26.1198V41.2309L48 48.7865M40.5 71.4531C48.4565 71.4531 56.0871 68.269 61.7132 62.6012C67.3393 56.9335 70.5 49.2463 70.5 41.2309C70.5 33.2155 67.3393 25.5283 61.7132 19.8606C56.0871 14.1928 48.4565 11.0087 40.5 11.0087C32.5435 11.0087 24.9129 14.1928 19.2868 19.8606C13.6607 25.5283 10.5 33.2155 10.5 41.2309C10.5 49.2463 13.6607 56.9335 19.2868 62.6012C24.9129 68.269 32.5435 71.4531 40.5 71.4531Z",
    stroke: "#1E1E1E",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.65aad915f17c8e8b2cf78c2742f331f5.svg";
export { ForwardRef as ReactComponent };